import type { LegalEntityCommandData } from '@festina/legalentity-general-types/legalentity'
import { LegalEntitySourcesService } from '@festina/legalentity-general-types/legalentity/services/LegalEntitySourcesService'
import { useFestinaMutation } from '@festina-life/authentication'

import type { SharedLegalEntityActionProps } from '../types'

type GeneralActionPropsWithCommandType = SharedLegalEntityActionProps

const method = LegalEntitySourcesService.legalEntitySourcesServicePostEvents
type MethodParam = LegalEntityCommandData

export const useCreateLegalEntityCommand = ({
  ownerId,
  tenantId,
}: GeneralActionPropsWithCommandType) =>
  useFestinaMutation({
    component: 'legalEntity',
    roles: LegalEntitySourcesService.legalEntitySourcesServicePostEvents_roles,
    isScenario: false,
    mutateFunction: async (arg: MethodParam) => {
      await method({
        xTenantId: tenantId,
        requestBody: {
          _type: 'EntityEventData',
          commandType: 'changeLegalEntity',
          event: arg,
          identification: {
            _type: 'Identification',
            identity: ownerId,
          },
        },
      })
    },
  })
